import Head from "next/head";
import React from "react";
import trackEvent from "services/mixpanel/mixpanel";
import { eventNames } from "services/mixpanel/events";
import { useBoolean } from "hooks/use-boolean/use-boolean";
import {
  PusatFaqData,
  FAQStructuredData
} from "components/faq-block/faq-block.data";
import { FAQ, FAQBlockProps } from "components/faq-block/faq-block.types";
import {
  FAQBlockContainer,
  FAQBlockTitle,
  FAQBlockWrapper,
  FAQContent,
  FAQItem,
  FAQListContainer,
  FAQListItem,
  FAQTitle
} from "components/faq-block/faq-block.styles";
import { AboutCTA } from "components/akademi-gurujuara/akademi-about/akademi-about.styles";
const NUMBER_OF_FAQ_VISIBLE_INITIALLY = 7;
import styled from "styled-components";

const HelpCenterFooter = styled.div`
  margin-top: 62px;
  margin-left: 35px;
  div {
    font-size: 20px;
  }

  a {
    display: inline-block;
    margin-top: 8px;
  }
`;

const ResponsiveCTA = styled(AboutCTA)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 15px 16px 0px 16px;
  border-radius: 0px;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-left: 2px;
    min-height: auto;
    width: auto;
    max-width: 250px;
  }
`;

const FAQPusatBantuan: React.FC<FAQBlockProps> = ({
  data = PusatFaqData,
  eventSource,
  showExpandCTA = false,
  showHeading = true
}) => {
  const showAllFAQ = useBoolean();
  const handleFAQItemClick = (faq: FAQ, index: number) => {
    trackEvent({
      eventName: eventNames.FAQExpandButtonClicked,
      payload: {
        source: eventSource || "",
        faqTitle: faq.title,
        faqDesc: faq.desc,
        faqPosition: index + 1
      }
    });
  };
  return (
    <>
      <Head>
        <title>FAQ Pusat Bantuan</title>
      </Head>
      <FAQBlockWrapper>
        <FAQBlockContainer>
          {showHeading && <FAQBlockTitle>Pusat Bantuan CoLearn</FAQBlockTitle>}
          <FAQListContainer>
            {data.map((faq, index) => (
              <FAQListItem
                key={`faq-list-item-${index}`}
                $isHidden={
                  showExpandCTA &&
                  !showAllFAQ &&
                  index >= NUMBER_OF_FAQ_VISIBLE_INITIALLY
                }
              >
                <FAQItem
                  onClick={() => handleFAQItemClick(faq, index)}
                  open={index === 0}
                >
                  <FAQTitle>{faq.title}</FAQTitle>
                  <FAQContent dangerouslySetInnerHTML={{ __html: faq.desc }} />
                </FAQItem>
              </FAQListItem>
            ))}
          </FAQListContainer>
        </FAQBlockContainer>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(FAQStructuredData(data))
          }}
        />
        <HelpCenterFooter>
          <div>Informasi lebih lengkap dapat diakses melalui link berikut:</div>
          <ResponsiveCTA rel="nofollow" href="/pusat-bantuan">
            Pusat Bantuan CoLearn
          </ResponsiveCTA>
        </HelpCenterFooter>
      </FAQBlockWrapper>
    </>
  );
};

export default FAQPusatBantuan;
